// Authored by Joe Kanakaraj
import React, { Suspense } from "react";
import Carousel from "react-elastic-carousel";
import Card from "../Card";
import Loading from "../Loading";
import "./styles.scss";
import LeftArrowOrange from "./assets/leftArrowOrange.svg";
import RightArrowOrange from "./assets/rightArrowOrange.svg";
// import { MOBILE_BREAKPOINTS } from "./constants";

const ElasticCarousel = ({
  carouselLabel,
  carouselData,
  loadingStatus,
  componentType,
}) => {
  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === "PREV" ? "arrowLeft" : "arrowRight";

    return (
      <button onClick={onClick} disabled={isEdge}>
        <div className="cmp-elastic-carousel-container">
          {pointer === "arrowLeft" && (
            <i
              className={`cmp-elastic-carousel-arrow cmp-elastic-carousel-${pointer} ${
                isEdge ? "cmp-elastic-carousel-arrow-hidden" : ""
              }`}
            >
              <img src={LeftArrowOrange} alt="Left Arrow" />
            </i>
          )}
          {pointer === "arrowRight" && (
            <i
              className={`cmp-elastic-carousel-arrow cmp-elastic-carousel-${pointer} ${
                isEdge ? "cmp-elastic-carousel-arrow-hidden" : ""
              }`}
            >
              <img src={RightArrowOrange} alt="Right Arrow" />
            </i>
          )}
        </div>
      </button>
    );
  };
  const breakPoints = [
    {
      width: 1,
      itemsToShow: 1,
      outerSpacing: [30],
      pagination: false,
      renderArrow: () => <></>,
      isRTL: false,
    },
    {
      width: 500,
      itemsToShow: 2,
      itemsToScroll: 2,
      pagination: false,
      outerSpacing: [30],
      itemPadding: [0, 11],
      renderArrow: () => <></>,
      isRTL: false,
    },
    {
      width: 800,
      itemsToShow: 3,
      itemsToScroll: 3,
      pagination: false,
      itemPadding: [0, 11],
      outerSpacing: [20],
      renderArrow: myArrow,
      isRTL: false,
    },
  ];
  return (
    <Suspense fallback={loadingStatus && <Loading size="large"/>}>
      <section className="cmp-elastic-carousel-label">{carouselLabel}</section>
      <section className="cmp-elastic-carousel">
        <Carousel isRTL={false} breakPoints={breakPoints}>
          {carouselData &&
            carouselData.map((item, idx) => {
              return (
                <Card
                  key={idx}
                  {...item}
                  showHide={""}
                  componentType={componentType}
                />
              );
            })}
        </Carousel>
      </section>
    </Suspense>
  );
};

export default ElasticCarousel;
